export default {_name:'Text.Alert',module:'Field',view:'Element/Text/Alert',options:{severity:'info',xs:'auto'}}